import React from "react";

const STATS = [
  { value: "20", label: "State-of-the-Art Kitchens" },
  { value: "04", label: "Delivery Platforms" },
  { value: "07", label: "Days a Week" },
];

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-28" data-testid="about-section">
      <div className="container-nk">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div>
            <p className="eyebrow">// About Naami Kitchens</p>
            <h2 className="font-display text-[56px] md:text-[80px] leading-[0.95] mt-3">
              Twenty Kitchens.<br />
              <span className="text-gold">Twenty Worlds</span><br />of Flavour.
            </h2>
          </div>

          <div className="flex flex-col gap-5 pt-2">
            <p className="text-[15.5px] leading-[1.75] text-[var(--text)]/80 font-light">
              Naami Kitchens is Edinburgh's premier ghost kitchen hub — twenty
              state-of-the-art professional kitchens under one roof, each home
              to an independent food brand with its own identity, menu and
              following. We share the infrastructure so they can focus on what
              matters: making great food.
            </p>
            <p className="text-[15.5px] leading-[1.75] text-[var(--text)]/80 font-light">
              Whether you walk straight up to our counter or tap an order in
              from the sofa, you get the same kitchen, the same chefs and the
              same uncompromising standards. Twenty brands. One roof. Edinburgh
              eats.
            </p>

            <div className="grid gap-3 mt-6">
              {STATS.map((s) => (
                <div className="stat-box" key={s.label} data-testid={`stat-${s.label.replace(/\s+/g, "-")}`}>
                  <span className="font-display text-[56px] text-gold leading-none">
                    {s.value}
                  </span>
                  <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted">
                    {s.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
